/**
 * Pre-compiled de messages for RichTextInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  bold: `Fett`,
  bulletedList: `Aufzählungsliste`,
  code: `Code`,
  headingFive: `Überschrift 5`,
  headingFour: `Überschrift 4`,
  headingOne: `Überschrift 1`,
  headingThree: `Überschrift 3`,
  headingTwo: `Überschrift 2`,
  italic: `Kursiv`,
  listFormatting: `Listenformatierung`,
  moreFormattingOptions: `Weitere Formatierungsoptionen`,
  moreStyles: `Weitere Stile`,
  numberedList: `Nummerierte Liste`,
  paragraph: `Paragraph`,
  quote: `Zitat`,
  redo: `Wiederherstellen`,
  strikethrough: `Durchstreichen`,
  subscript: `Tiefgestellt`,
  superscript: `Hochgestellt`,
  textFormatting: `Textformatierung`,
  textStyle: `Textstil`,
  textStyleMenu: `Textstilmenü`,
  underline: `Unterstreichen`,
  undo: `Rückgängig machen`,
};
